module.exports = __webpack_public_path__ + "static/hda-86b49ab71e65bedb10ee18e25859fb63.jpg";